export const ProductsIcon = () => (
  <svg
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-macaw-ui-candidate
  >
    <g clipPath="url(#a)" fill="currentColor">
      <path d="M17.84 9.508 10.48 2.15a1.665 1.665 0 0 0-1.174-.483H3.33c-.917 0-1.667.75-1.667 1.666v5.975c0 .442.175.867.492 1.175l7.358 7.359c.65.65 1.708.65 2.358 0l5.975-5.975c.65-.65.65-1.7-.008-2.359Zm-7.15 7.159L3.33 9.308V3.333h5.976l7.358 7.359-5.975 5.975Z" />
      <path d="M5.414 6.667a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
